<template>
  <div class="card border-0 shadow-none rounded-1 mb-25">
    <div class="card-body p-xl-40">
      <div class="table-responsive style-three">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-title fw-normal fs-14 pt-0 ps-0">
                <div class="form-check checkbox">
                  <input class="form-check-input" type="checkbox" id="test_1" />
                  <label class="form-check-label" for="test_1">
                    {{ t("expense_page.date") }}
                    <img
                      class="ms-2"
                      src="../../../assets/img/icons/up-down-aroow.svg"
                      alt="Image"
                    />
                  </label>
                </div>
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0">
                {{ t("expense_page.reference") }}
                <img
                  class="ms-2"
                  src="../../../assets/img/icons/up-down-aroow.svg"
                  alt="Image"
                />
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0">
                {{ t("expense_page.warehouse") }}
                <img
                  class="ms-2"
                  src="../../../assets/img/icons/up-down-aroow.svg"
                  alt="Image"
                />
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0">
                {{ t("expense_page.category") }}
                <img
                  class="ms-2"
                  src="../../../assets/img/icons/up-down-aroow.svg"
                  alt="Image"
                />
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0">
                {{ t("expense_page.amount") }}
                <img
                  class="ms-2"
                  src="../../../assets/img/icons/up-down-aroow.svg"
                  alt="Image"
                />
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0">
                {{ t("expense_page.details") }}
                <img
                  class="ms-2"
                  src="../../../assets/img/icons/up-down-aroow.svg"
                  alt="Image"
                />
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0 pe-0">
                {{ t("expense_page.action") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="expenses.length === 0">
              <td colspan="7" class="text-center py-4">{{ t("expense_page.no_expenses_found") }}</td>
            </tr>
            <tr v-for="expense in paginatedExpenses" :key="expense.id">
              <td class="shadow-none fw-normal text-black title ps-0">
                <div class="d-flex align-items-center">
                  <div class="form-check checkbox style-three">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :id="'checkbox_' + expense.id"
                    />
                    <label class="form-check-label text-optional" :for="'checkbox_' + expense.id">
                    </label>
                  </div>
                  <span class="text-optional fs-14 ms-2">{{
                    formatDateTime(expense.date)
                  }}</span>
                </div>
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                {{ expense.referenceno }}
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                {{ expense.warehouse?.name || t("expense_page.not_available") }}
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                {{ expense.category?.name || expense.category_name || t("expense_page.not_available") }}
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                ${{ Number(expense.amount).toFixed(2) }}
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                {{ expense.description || t("expense_page.no_description") }}
              </td>
              <td class="shadow-none lh-1 text-end pe-0">
                <div class="button-group d-flex flex-wrap align-items-center">
                  <a
                    href="javascript:void(0)"
                    :title="t('expense_page.view')"
                    data-bs-toggle="modal"
                    data-bs-target="#detailsModal"
                    @click="viewDetails(expense)"
                  >
                    <img src="../../../assets/img/icons/eye.svg" :alt="t('expense_page.view')" />
                  </a>
                  <router-link :to="`/edit-expense/${expense.id}`" :title="t('expense_page.edit')">
                    <img src="../../../assets/img/icons/edit.svg" :alt="t('expense_page.edit')" />
                  </router-link>
                  <a
                    class="delete-btn"
                    href="javascript:void(0)"
                    :title="t('expense_page.delete')"
                    @click="confirmDelete(expense.id)"
                  >
                    <img
                      src="../../../assets/img/icons/close.svg"
                      :alt="t('expense_page.delete')"
                    />
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="row pb-45 align-items-center">
    <div class="col-sm-6">
      <div
        class="d-flex flex-wrap align-items-center justify-content-center justify-content-sm-start page-unit"
      >
        <span class="fs-13">{{ t("expense_page.showing_expense_per_page") }}</span>
        <select class="text-title border-0 fs-14 bg-transparent" v-model="itemsPerPage">
          <option :value="5">5</option>
          <option :value="10">10</option>
          <option :value="20">20</option>
          <option :value="50">50</option>
          <option :value="10000">{{ t("common.all") }}</option>
        </select>
      </div>
    </div>
    <div class="col-sm-6 text-sm-end text-center">
      <ul class="page-nav list-style">
        <li>
          <a href="javascript:void(0)" @click="prevPage" :class="{ disabled: currentPage === 1 }">
            <img
              src="../../../assets/img/icons/left-arrow-purple.svg"
              alt="Image"
            />
          </a>
        </li>
        <li v-for="page in totalPages" :key="page">
          <a href="javascript:void(0)" :class="{ active: currentPage === page }" @click="goToPage(page)">{{ page }}</a>
        </li>
        <li>
          <a href="javascript:void(0)" @click="nextPage" :class="{ disabled: currentPage === totalPages }">
            <img
              src="../../../assets/img/icons/right-arrow-purple.svg"
              alt="Image"
            />
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, computed, watch } from "vue";
import { useI18n } from "vue-i18n";
import expenseService, { type ExpenseFilters } from "../../../services/expense";
import Swal from 'sweetalert2';

export default defineComponent({
  name: "ExpensesList",
  props: {
    searchQuery: {
      type: String,
      default: ""
    },
    filters: {
      type: Object as () => ExpenseFilters,
      default: () => ({
        warehouse_id: "",
        category_id: "",
        from_date: "",
        to_date: "",
      })
    }
  },
  emits: ["view-details"],
  setup(props, { emit }) {
    const { t, locale } = useI18n();
    const expenses = ref<any[]>([]);
    const isLoading = ref(false);
    const currentPage = ref(1);
    const itemsPerPage = ref(10);

    const formatDateTime = (value?: string) => {
      if (!value) return t("expense_page.not_available");

      return new Date(value).toLocaleString(locale.value === "km" ? "km-KH" : "en-GB", {
        timeZone: "Asia/Phnom_Penh",
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      });
    };

    const filteredExpenses = computed(() => {
      const query = (props.searchQuery || "").trim().toLowerCase();

      return expenses.value.filter((expense) => {
        const matchesSearch =
          !query ||
          [
            expense.referenceno,
            expense.name,
            expense.description,
            expense.category?.name,
            expense.category_name,
            expense.warehouse?.name,
            expense.date ? formatDateTime(expense.date) : "",
          ]
            .filter(Boolean)
            .some((value) => String(value).toLowerCase().includes(query));

        const matchesWarehouse =
          !props.filters?.warehouse_id ||
          String(expense.warehouse_id ?? expense.warehouse?.id ?? "") === String(props.filters.warehouse_id);

        const matchesCategory =
          !props.filters?.category_id ||
          String(expense.category_id ?? expense.category?.id ?? "") === String(props.filters.category_id);

        const expenseDate = expense.date ? new Date(expense.date) : null;
        const fromDate = props.filters?.from_date ? new Date(props.filters.from_date) : null;
        const toDate = props.filters?.to_date ? new Date(props.filters.to_date) : null;

        const matchesFromDate = !fromDate || (expenseDate && expenseDate >= fromDate);
        const matchesToDate =
          !toDate ||
          (expenseDate &&
            expenseDate <= new Date(
              `${props.filters.to_date}T23:59:59`
            ));

        return (
          matchesSearch &&
          matchesWarehouse &&
          matchesCategory &&
          matchesFromDate &&
          matchesToDate
        );
      });
    });

    const paginatedExpenses = computed(() => {
      const start = (currentPage.value - 1) * itemsPerPage.value;
      const end = start + itemsPerPage.value;
      return filteredExpenses.value.slice(start, end);
    });

    const totalPages = computed(() => {
      return Math.ceil(filteredExpenses.value.length / itemsPerPage.value) || 1;
    });

    const goToPage = (page: number) => {
      currentPage.value = page;
    };

    const prevPage = () => {
      if (currentPage.value > 1) {
        currentPage.value--;
      }
    };

    const nextPage = () => {
      if (currentPage.value < totalPages.value) {
        currentPage.value++;
      }
    };

    watch(
      () => [props.searchQuery, props.filters?.warehouse_id, props.filters?.category_id, props.filters?.from_date, props.filters?.to_date],
      () => {
        currentPage.value = 1;
        fetchExpenses();
      }
    );

    const fetchExpenses = async () => {
      isLoading.value = true;
      try {
        const data = await expenseService.getExpenses({
          q: props.searchQuery,
          warehouse_id: props.filters?.warehouse_id,
          category_id: props.filters?.category_id,
          from_date: props.filters?.from_date,
          to_date: props.filters?.to_date,
        });
        expenses.value = data;
      } catch (error) {
        console.error("Error fetching expenses:", error);
      } finally {
        isLoading.value = false;
      }
    };

    const confirmDelete = async (id: number) => {
      const result = await Swal.fire({
        title: t("expense_page.are_you_sure"),
        text: t("expense_page.revert_warning"),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: t("expense_page.yes_delete_it"),
        cancelButtonText: t("common.cancel"),
      });

      if (result.isConfirmed) {
        try {
          await expenseService.deleteExpense(id);
          Swal.fire(
            t("expense_page.deleted"),
            t("expense_page.expense_deleted_successfully"),
            'success'
          );
          await fetchExpenses();
        } catch (error) {
          console.error("Error deleting expense:", error);
          Swal.fire(
            t("expense_page.error"),
            t("expense_page.failed_to_delete_expense"),
            'error'
          );
        }
      }
    };

    const viewDetails = (expense: any) => {
      emit("view-details", expense);
    };

    const exportExcel = () => {
      // Simple CSV export
      const headers = [
        t("expense_page.date"),
        t("expense_page.reference"),
        t("expense_page.warehouse"),
        t("expense_page.category"),
        t("expense_page.amount"),
        t("expense_page.description"),
      ];
      
      const escapeCsv = (field: any) => {
        if (field === null || field === undefined) return "";
        const stringField = String(field);
        if (stringField.includes(",") || stringField.includes('"') || stringField.includes("\n")) {
          return `"${stringField.replace(/"/g, '""')}"`;
        }
        return stringField;
      };

      const rows = filteredExpenses.value.map(expense => [
        escapeCsv(formatDateTime(expense.date)),
        escapeCsv(expense.referenceno),
        escapeCsv(expense.warehouse?.name || t("expense_page.not_available")),
        escapeCsv(expense.category?.name || expense.category_name || t("expense_page.not_available")),
        escapeCsv(expense.amount),
        escapeCsv(expense.description || t("expense_page.no_description"))
      ]);

      const csvContent = [
        headers.join(","),
        ...rows.map(row => row.join(","))
      ].join("\n");

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", `${t("expense_page.export_file_name")}.csv`);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    onMounted(() => {
      fetchExpenses();
    });

    return {
      expenses,
      paginatedExpenses,
      isLoading,
      fetchExpenses,
      confirmDelete,
      viewDetails,
      currentPage,
      itemsPerPage,
      totalPages,
      goToPage,
      prevPage,
      nextPage,
      exportExcel,
      formatDateTime,
      t,
    };
  },
});
</script>
